export const isNamespaceStaging = () => process.env.GATSBY_NAMESPACE_ENV === 'staging';
export const isNamespaceProduction = () => process.env.GATSBY_NAMESPACE_ENV === 'production';
